import React, { useEffect, useState, useRef } from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import ReactPlayer from 'react-player';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

function Vehicledetails() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const [vehicle, setVehicle] = useState(null);
  const [vehcileImages, setVehicleImages] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const swiperRef = useRef(null);

  useEffect(() => {
    if (id) {
      axios
        .post(`${baseUrl}/vehicle/details`, { id: id })
        .then((response) => {
          setVehicle(response.data.details);
        })
        .catch((error) => {
          console.error("Failed to fetch vehicle details:", error);
        });

      axios
        .post(`${baseUrl}/vehicle/images`, { vehicle_id: id })
        .then((response) => {
          setVehicleImages(response.data.data);
          console.log('Images',response.data.data)
        })
        .catch((error) => {
          console.error("Failed to fetch vehicle images:", error);
        });
    }
  }, [id]);

  const handlePlay = () => {
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.stop();
    }
  };

  const handlePauseOrEnd = () => {
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.start();
    }
  };

  return (
    <>
      
      <Header />
      <section className="service-sec15 space" id="service-sec" style={{ backgroundImage: "url('/assets/img/hero/hero_bg_15_1.png')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center" }}>
        <div className="container th-container4">
          <div className="row justify-content-center">
            

            <div className=" row body blog-box2 style2">
              <div className="col-12 col-xl-6 col-md-6 ">
                <div className="card">
                <div className="mb-3 d-flex align-items-center justify-content-center w-100">
                  <Swiper  modules={[Navigation, Pagination, Autoplay]} spaceBetween={10} slidesPerView={1}  navigation pagination={{ clickable: true }} autoplay={{ delay: 3000 }}  loop={true} onSwiper={(swiper) => (swiperRef.current = swiper)}>
                    {vehcileImages.map((item, index) => (
                      <SwiperSlide key={index} className="d-flex justify-content-center align-items-center">
                        {item.type === 'image' ? (
                          <img
                          className="img-fluid rounded m-1"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          src={item.url || 'assets/img/brand/brand_8_1.svg'}
                          alt={item.name || 'Vehicle Media'}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'assets/img/brand/brand_8_1.svg'; // fallback image
                          }}
                        />
                        ) : item.type === 'video' && item.url.includes('youtube.com') ? (
                          <div className="m-1" style={{ width: '100%', maxWidth: '100%', aspectRatio: '16/9' }}>
                            <ReactPlayer  url={item.url}  width="100%" height="100%" controls onPlay={handlePlay} onPause={handlePauseOrEnd}  onEnded={handlePauseOrEnd} config={{ youtube: { playerVars: { origin: window.location.origin, },  }, }} />
                          </div>
                        ) : null}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                </div>
              </div>
              <div className="col-12 col-xl-6 col-md-6 ">
              <h4>{vehicle ? vehicle.brand + ' ' + vehicle.model : 'Loading...'}</h4>
               <div>
               <h6>  {vehicle? vehicle.rating : '0'}{" "}  <i className="fa-sharp fa-solid fa-star text-warning" width="20px" /> </h6>
               </div>
                <div className="mt-2">
                    <h6><b>Description</b> </h6>
                    <span className="mt-0">{vehicle ? vehicle.description : 'Loading...'}</span>

                </div>
                <div className="mt-3">
                   <h5> Rs {vehicle? vehicle.price : '0'} <span>/Days</span> </h5>
                   <button className="th-btn btn-sm">Book Now</button>
                </div>
                
              </div>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Vehicledetails;
